export const RESET = 'CURRENCY_UPDATE_RESET'
export const SET_ERROR = 'CURRENCY_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'CURRENCY_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'CURRENCY_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'CURRENCY_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'CURRENCY_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'CURRENCY_UPDATE_UPDATE_RETRIEVED'
export const SET_FILES = 'CURRENCY_UPDATE_FILES'
